import axios from "axios";
import { clearAuthStorage, getAuthItem } from "@/utils/authStorage";

let isRedirecting = false; // Flag to prevent multiple redirects

let headers = {};
let headersWithImages = { "Content-Type": "multipart/form-data" };

async function makeApiCall(
  url, // FIRST PARAM  FOR END POINT
  method = "GET", // SECOND PARAM FOR METHOD TYPE BY DEFAULT GET
  data, //THIRD PARAM FOR DATA/BODY
  noAuth, //4TH IF WE HAVE TO DEAL WITH AUTH
  sendConfig,
  ...config
) {
  try {
    const roomround_access_token = getAuthItem("roomround_access_token");

    if (roomround_access_token !== null) {
      headers.Authorization = `Bearer ${roomround_access_token}`;
    }

    const response = await axios({
      method,
      data,
      headers,
      url: `${process.env.VUE_APP_API_URL}${url}`,
      ...config,
    });

    if (sendConfig) {
      return response;
    }

    return response;
  } catch (error) {
    if (error?.response && error?.response?.status === 401) {
      clearAuthStorage();
      window.location.href = "/login";
    }
  }
}
async function makeApiCallWithImages(
  url, // FIRST PARAM FOR ENDPOINT
  method = "GET", // SECOND PARAM FOR METHOD TYPE BY DEFAULT GET
  data, // THIRD PARAM FOR DATA/BODY
  noAuth, // 4TH PARAM IF WE HAVE TO DEAL WITH AUTH
  sendConfig,
  ...config
) {
  const roomround_access_token = getAuthItem("roomround_access_token");

  if (roomround_access_token !== null) {
    headersWithImages.Authorization = `Bearer ${roomround_access_token}`;
  }

  try {
    const response = await axios({
      method,
      data,
      headers: headersWithImages,
      url: `${process.env.VUE_APP_API_URL}${url}`,
      ...config,
    });

    if (sendConfig) {
      return response;
    }

    return response;
  } catch (error) {
    if (error.response && error.response.status === 401 && !isRedirecting) {
      isRedirecting = true;

      clearAuthStorage();
      window.location.href = "/login";
      isRedirecting = false;
    } else {
      console.error("API error:", error);
      return Promise.reject(error);
    }
  }
}

export { makeApiCall, makeApiCallWithImages };
